"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getProperties = exports.releaseObj = exports.getObj = exports.wrap = exports.clear = void 0;
var toStr_1 = __importDefault(require("licia/toStr"));
var isNull_1 = __importDefault(require("licia/isNull"));
var isArr_1 = __importDefault(require("licia/isArr"));
var isFn_1 = __importDefault(require("licia/isFn"));
var isEl_1 = __importDefault(require("licia/isEl"));
var isErr_1 = __importDefault(require("licia/isErr"));
var isMap_1 = __importDefault(require("licia/isMap"));
var isSet_1 = __importDefault(require("licia/isSet"));
var isRegExp_1 = __importDefault(require("licia/isRegExp"));
var type_1 = __importDefault(require("licia/type"));
var keys_1 = __importDefault(require("licia/keys"));
var toSrc_1 = __importDefault(require("licia/toSrc"));
var allKeys_1 = __importDefault(require("licia/allKeys"));
var isNative_1 = __importDefault(require("licia/isNative"));
var getProto_1 = __importDefault(require("licia/getProto"));
var isSymbol_1 = __importDefault(require("licia/isSymbol"));
var has_1 = __importDefault(require("licia/has"));
var objects = new Map();
var objectIds = new Map();
var selfs = new Map();
var entries = new Map();
var id = 1;
function getOrCreateObjId(obj, self) {
    var objId = objectIds.get(obj);
    if (objId)
        return objId;
    objId = JSON.stringify({
        injectedScriptId: 0,
        id: id++,
    });
    objectIds.set(obj, objId);
    objects.set(objId, obj);
    selfs.set(objId, self);
    return objId;
}
function clear() {
    objects.clear();
    objectIds.clear();
    selfs.clear();
}
exports.clear = clear;
function wrap(value, _a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.generatePreview, generatePreview = _c === void 0 ? false : _c, _d = _b.self, self = _d === void 0 ? value : _d;
    var ret = basic(value);
    var type = ret.type, subtype = ret.subtype;
    if (type === 'undefined') {
        return ret;
    }
    if (type === 'string' || type === 'boolean' || subtype === 'null') {
        ret.value = value;
        return ret;
    }
    ret.description = getDescription(value, self);
    if (type === 'number') {
        ret.value = value;
        return ret;
    }
    if (type === 'symbol') {
        ret.objectId = getOrCreateObjId(value, self);
        return ret;
    }
    if (type === 'function') {
        ret.className = 'Function';
    }
    else if (subtype === 'array') {
        ret.className = 'Array';
    }
    else if (subtype === 'map') {
        ret.className = 'Map';
    }
    else if (subtype === 'set') {
        ret.className = 'Set';
    }
    else if (subtype === 'regexp') {
        ret.className = 'RegExp';
    }
    else if (subtype === 'error') {
        ret.className = value.name;
    }
    else {
        ret.className = type_1.default(value, false);
    }
    if (generatePreview) {
        ret.preview = getPreview(value, self);
    }
    ret.objectId = getOrCreateObjId(value, self);
    return ret;
}
exports.wrap = wrap;
function getObj(objectId) {
    return objects.get(objectId);
}
exports.getObj = getObj;
function releaseObj(objectId) {
    var object = getObj(objectId);
    objectIds.delete(object);
    selfs.delete(objectId);
    objects.delete(objectId);
}
exports.releaseObj = releaseObj;
function getProperties(params) {
    var accessorPropertiesOnly = params.accessorPropertiesOnly, objectId = params.objectId, ownProperties = params.ownProperties, generatePreview = params.generatePreview;
    var properties = [];
    var options = {
        prototype: !ownProperties,
        unenumerable: true,
        symbol: !accessorPropertiesOnly,
    };
    var obj = objects.get(objectId);
    var self = selfs.get(objectId);
    var keys = allKeys_1.default(obj, options);
    var proto = getProto_1.default(obj);
    for (var i = 0, len = keys.length; i < len; i++) {
        var name_1 = keys[i];
        var propVal = void 0;
        try {
            propVal = self[name_1];
        }
        catch (e) {
        }
        var property = {
            name: toStr_1.default(name_1),
            isOwn: has_1.default(self, name_1),
        };
        var descriptor = Object.getOwnPropertyDescriptor(obj, name_1);
        if (!descriptor && proto) {
            descriptor = Object.getOwnPropertyDescriptor(proto, name_1);
        }
        if (descriptor) {
            if (accessorPropertiesOnly) {
                if (!descriptor.get && !descriptor.set) {
                    continue;
                }
            }
            property.configurable = descriptor.configurable;
            property.enumerable = descriptor.enumerable;
            property.writable = descriptor.writable;
            if (descriptor.get) {
                property.get = wrap(descriptor.get);
            }
            if (descriptor.set) {
                property.set = wrap(descriptor.set);
            }
        }
        if (proto && has_1.default(proto, name_1) && property.enumerable) {
            property.isOwn = true;
        }
        var accessValue = true;
        if (!property.isOwn && property.get)
            accessValue = false;
        if (accessValue) {
            if (isSymbol_1.default(name_1)) {
                property.symbol = wrap(name_1);
                property.value = { type: 'undefined' };
            }
            else {
                property.value = wrap(propVal, {
                    generatePreview: generatePreview,
                });
            }
        }
        if (accessorPropertiesOnly) {
            if (isFn_1.default(propVal) && isNative_1.default(propVal))
                continue;
        }
        properties.push(property);
    }
    if (proto && !ownProperties && !noPrototype(obj)) {
        properties.push({
            name: '__proto__',
            configurable: true,
            enumerable: false,
            isOwn: has_1.default(obj, '__proto__'),
            value: wrap(proto, {
                self: self,
            }),
            writable: false,
        });
    }
    if (accessorPropertiesOnly) {
        return {
            result: properties,
        };
    }
    var internalProperties = [];
    if (proto && !noPrototype(obj)) {
        internalProperties.push({
            name: '[[Prototype]]',
            value: wrap(proto, {
                self: self,
            }),
        });
    }
    if (isMap_1.default(obj) || isSet_1.default(obj)) {
        var internalEntries = createInternalEntries(obj);
        internalProperties.push({
            name: '[[Entries]]',
            value: wrap(internalEntries),
        });
    }
    return {
        internalProperties: internalProperties,
        result: properties,
    };
}
exports.getProperties = getProperties;
var MAX_PREVIEW_LEN = 5;
function getPreview(obj, self) {
    if (self === void 0) { self = obj; }
    var ret = basic(obj);
    ret.description = getDescription(obj, self);
    var overflow = false;
    var properties = [];
    var keys = keys_1.default(obj);
    var len = keys.length;
    if (len > MAX_PREVIEW_LEN) {
        len = MAX_PREVIEW_LEN;
        overflow = true;
    }
    for (var i = 0; i < len; i++) {
        var name_2 = keys[i];
        properties.push(getPropertyPreview(name_2, self[name_2]));
    }
    ret.properties = properties;
    if (isMap_1.default(obj)) {
        var entries_1 = [];
        var i = 0;
        var keys_2 = obj.keys();
        var key = keys_2.next().value;
        while (key) {
            if (i > MAX_PREVIEW_LEN) {
                overflow = true;
                break;
            }
            entries_1.push({
                key: getPreview(key),
                value: getPreview(obj.get(key)),
            });
            i++;
            key = keys_2.next().value;
        }
        ret.entries = entries_1;
    }
    else if (isSet_1.default(obj)) {
        var entries_2 = [];
        var i = 0;
        var keys_3 = obj.keys();
        var key = keys_3.next().value;
        while (key) {
            if (i > MAX_PREVIEW_LEN) {
                overflow = true;
                break;
            }
            entries_2.push({
                value: getPreview(key),
            });
            i++;
            key = keys_3.next().value;
        }
        ret.entries = entries_2;
    }
    ret.overflow = overflow;
    return ret;
}
function getPropertyPreview(name, propVal) {
    var property = basic(propVal);
    property.name = name;
    var subtype = property.subtype, type = property.type;
    var value;
    if (type === 'object') {
        if (subtype === 'null') {
            value = 'null';
        }
        else if (subtype === 'array') {
            value = "Array(" + propVal.length + ")";
        }
        else if (subtype === 'map') {
            value = "Map(" + propVal.size + ")";
        }
        else if (subtype === 'set') {
            value = "Set(" + propVal.size + ")";
        }
        else {
            value = type_1.default(propVal, false);
        }
    }
    else {
        value = toStr_1.default(propVal);
    }
    property.value = value;
    return property;
}
function getDescription(obj, self) {
    if (self === void 0) { self = obj; }
    var description = '';
    var _a = basic(obj), type = _a.type, subtype = _a.subtype;
    if (type === 'string') {
        description = obj;
    }
    else if (type === 'number') {
        description = toStr_1.default(obj);
    }
    else if (type === 'symbol') {
        description = toStr_1.default(obj);
    }
    else if (type === 'function') {
        description = toSrc_1.default(obj);
    }
    else if (subtype === 'array') {
        description = "Array(" + obj.length + ")";
    }
    else if (subtype === 'map') {
        description = "Map(" + self.size + ")";
    }
    else if (subtype === 'set') {
        description = "Set(" + self.size + ")";
    }
    else if (subtype === 'regexp') {
        description = toStr_1.default(obj);
    }
    else if (subtype === 'error') {
        description = obj.stack;
    }
    else if (subtype === 'internal#entry') {
        if (obj.name) {
            description = "{\"" + toStr_1.default(obj.name) + "\" => \"" + toStr_1.default(obj.value) + "\"}";
        }
        else {
            description = "\"" + toStr_1.default(obj.value) + "\"";
        }
    }
    else {
        description = type_1.default(obj, false);
    }
    return description;
}
function basic(value) {
    var type = typeof value;
    var subtype = 'object';
    if (value instanceof InternalEntry) {
        subtype = 'internal#entry';
    }
    else if (isNull_1.default(value)) {
        subtype = 'null';
    }
    else if (isArr_1.default(value)) {
        subtype = 'array';
    }
    else if (isRegExp_1.default(value)) {
        subtype = 'regexp';
    }
    else if (isErr_1.default(value)) {
        subtype = 'error';
    }
    else if (isMap_1.default(value)) {
        subtype = 'map';
    }
    else if (isSet_1.default(value)) {
        subtype = 'set';
    }
    else {
        try {
            if (isEl_1.default(value)) {
                subtype = 'node';
            }
        }
        catch (e) {
        }
    }
    return {
        type: type,
        subtype: subtype,
    };
}
var InternalEntry = (function () {
    function InternalEntry(value, name) {
        if (name) {
            this.name = name;
        }
        this.value = value;
    }
    return InternalEntry;
}());
function noPrototype(obj) {
    if (obj instanceof InternalEntry) {
        return true;
    }
    if (obj[0] && obj[0] instanceof InternalEntry) {
        return true;
    }
    return false;
}
function createInternalEntries(obj) {
    var entryId = entries.get(obj);
    var internalEntries = entryId ? getObj(entryId) : [];
    var objEntries = obj.entries();
    var entry = objEntries.next().value;
    while (entry) {
        if (isMap_1.default(obj)) {
            internalEntries.push(new InternalEntry(entry[1], entry[0]));
        }
        else {
            internalEntries.push(new InternalEntry(entry[1]));
        }
        entry = objEntries.next().value;
    }
    return internalEntries;
}
